const NotFound = () => {
	return (
		<div className="col-lg-12">
			<div className="card card-forum">
				<div className="card-header usa-bg">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-12">
								<h4 className="text-white d-flex mb-0 py-2">Page Not Found!</h4>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body bg-white p-1 body-minh">
					<div className="row">
						<div className="col-12 event_n mb-1">
							<div className="card-grid-2 hover-up h-100 mb-0">
								<div className="ne-img-175">
									<img src="/assets/images/no-image.jpg" alt="..." />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NotFound;
